var map = {
	"./fortuneIcon.svg": 755,
	"./fortuneIconL.svg": 756,
	"./helpdeskIcon.svg": 757,
	"./helpdeskIconL.svg": 758,
	"./homeIcon.svg": 759,
	"./homeIconLarge.svg": 760,
	"./jackpotIcon.svg": 761,
	"./logo.svg": 762,
	"./logoSmall.svg": 763,
	"./loyaltyIcon.svg": 764,
	"./mobileAppIcon.svg": 765,
	"./profileIcon.svg": 766,
	"./questIcon.svg": 767,
	"./questsIcon.svg": 768,
	"./rewardLineupIcon.svg": 769,
	"./searchIcon.svg": 770,
	"./searchIconLarge.svg": 771,
	"./signOutIcon.svg": 772,
	"./star.svg": 773,
	"./tournamentIcon.svg": 774,
	"./tournamentLargeIcon.svg": 775,
	"./vipIcon.svg": 776,
	"./wheelIcon.svg": 777,
	"./wheelIconL.svg": 778,
	"./wheelIconMobile.svg": 779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 754;